<script lang="ts">
  import { Router, Link, Route } from "svelte-routing";
  import { SvelteToast } from "@zerodevx/svelte-toast";
  import Navbar from "./components/Navbar.svelte";
  import Home from "./components/Home.svelte";
  import Contact from "../public/images/Contact.svelte";
  import CaseStudyListing from "./components/CaseStudyListing.svelte";
  import VulCaseStudy from "./components/CaseStudyVul.svelte";
  import GmgtCaseStudy from "./components/CaseStudyGmgt.svelte";
  import Estimator from "./routes/Estimator.svelte";
  import Newsletter from "./routes/NewsletterPage.svelte";
  import Footer from "./components/Footer.svelte";
  import Technologies from "./routes/Technologies.svelte";
  import About from "./routes/About.svelte";
  import Blog from "./routes/Blog.svelte";
  import BlogPost from "./routes/BlogPost.svelte";
  import NotFound from "./routes/NotFound.svelte";
  let page;
  let params;
  let name = "world";
  let env = __myapp.env.NODE_ENV;
  let title = "Code World Solutions";

  export let url = "";
</script>

<style global lang="postcss">
  /* only apply purgecss on utilities, per Tailwind docs */
  /* purgecss start ignore */
  @tailwind base;
  @tailwind components;
  /* purgecss end ignore */

  @tailwind utilities;

  @layer utilities {
    .text-gradient {
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
</style>

<svelte:head>
  <link rel="stylesheet" href="/assets/css/material-kit.css?v=2.0.7" />
  <link
    rel="stylesheet"
    type="text/css"
    href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Roboto+Slab:400,700|Material+Icons" />
  <link
    rel="stylesheet"
    href="https://maxcdn.bootstrapcdn.com/font-awesome/latest/css/font-awesome.min.css" />
</svelte:head>
<div class="index-page sidebar-collapse white-bg">
  <SvelteToast />
  <Navbar {title} />
</div>
<Router {url}>
  <div>
    <Route path="case-study/vul" component={VulCaseStudy} />
    <Route path="case-study/gmgt" component={GmgtCaseStudy} />
    <Route path="contact" component={Contact} />
    <Route path="case-study" component={CaseStudyListing} />
    <Route path="estimator" component={Estimator} />
    <Route path="newsletter" component={Newsletter} />
    <Route path="technologies" component={Technologies} />
    <Route path="about" component={About} />
    <Route path="blog/:id" let:params>
      <BlogPost id={params.id} />
    </Route>
    <Route path="blog" component={Blog} />
    <Route path="/">
      <Home />
    </Route>
    <Route component={NotFound} />
    <Footer />
  </div>
</Router>
